$(document).ready(function () {
    $(document).on('click', '#process_request_wallet', function (event) {
        event.preventDefault();
        $.ajax({
            url: window.location.origin + '/process/e-wallet/cancellations',
            type: 'GET',
        })
            .done(function (response) {
                document.getElementById('div_respone_wallet').innerHTML = response;
                //$('#modal-permissions').modal("show");
            })
            .fail(function (jqXHR, textStatus) {
                console.log(jqXHR);
                alert("Disculpe, existió un problema");
            });
    });

    $("#open-wallet-modal").on('click', function (e) {
        e.preventDefault();
        $("#modal-wallets").modal("show");
        let divRepeatWallets = $('#div_repeat_wallets');
        divRepeatWallets.empty();
    })


    $("#form-add-wallets").on('submit', function (e) {
        e.preventDefault();
        e.preventDefault();
        togglePreloader();
        let data = new FormData(this);
        $.ajax({
            url: 'add-wallets-from-web', type: "post", data: data, processData: false, contentType: false, headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }, success: function (response) {
                setTimeout(() => {
                    togglePreloader();

                    if (response.success === "true") {

                        $("#file").val('')
                        alertSuccess(response.msg)
                        let repeatWallets = response.repeatWallets;
                        let divRepeatWallets = $('#div_repeat_wallets');
                        divRepeatWallets.empty();

                        if (repeatWallets.length > 0) {
                            divRepeatWallets.append('<h3>Monederos Repetidos:</h3>');
                            var list = $('<ul></ul>');
                            repeatWallets.forEach(function(wallet) {
                                list.append('<li>' + wallet + '</li>');
                            });
                            divRepeatWallets.append(list);
                        } else {
                            divRepeatWallets.append('<p>No hay monederos repetidos.</p>');
                        }
                    }

                    if (response.success === "false") {
                        togglePreloader();
                        alertError(response.msg)
                    }
                }, "2000");
            }, error: function (errors, xhr, status,) {
                togglePreloader();
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    console.log(index,value)
                    alertError(value)
                });
            }
        });
    })



    $("#form-add-wallet").on('submit', function (e) {
        e.preventDefault();
        togglePreloader();
        let data = new FormData(this);
        $.ajax({
            url: 'add-wallet-from-web', type: "post", data: data, processData: false, contentType: false, headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }, success: function (response) {

                setTimeout(() => {
                    togglePreloader();
                    if (response.success === "true") {
                        clearInputs();
                        alertSuccess(response.msg)
                    }
                    if (response.success === "false") {
                        alertError(response.msg)
                    }
                }, "3000");
            }, error: function (errors, xhr, status,) {
                togglePreloader();
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                });
            }
        });
    })

    function clearInputs() {
        $(".numcard").val('')
        $(".name").val('')
        $(".phone").val('')
    }

});
